// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"e935a521","208":"594d05f7","423":"300c821e","540":"2bd06ea0","702":"5852c73e","879":"8fb704e3"}[chunkId] + ".chunk.css";
};